import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericGet } from '@/_shared/types';
import { GenericApiError } from '@/_shared/types/apiError';
import { API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_ID_PATH_KEY } from '@/swagger/constants/surveys-keys';
import { API_GET_SURVEYS_TEMPLATE_BY_ID_CALL, KEY_GET_TEMPLATE_BY_ID } from '../constats';
import { MOCK_RESPONSE_GET_TEMPLATE_BY_ID } from '../mocks';

type RequestGetTemplateById = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_ID_PATH_KEY
>['request']['path'];

type ResponseGetTemplateById = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_ID_PATH_KEY
>['response']['body'];

type CallParamsGetTemplateById = RequestGetTemplateById & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

export type CallResponseGetTemplateById = ResponseGetTemplateById;

type CallErrorGetTemplateById = GenericApiError;

type CallSelectorsGetTemplateById = unknown;

export const getTemplateByIdCall = createGeneralCall<
  CallParamsGetTemplateById,
  CallResponseGetTemplateById,
  CallErrorGetTemplateById,
  CallSelectorsGetTemplateById
>({
  id: KEY_GET_TEMPLATE_BY_ID,
  method: 'get',
  url:
    ({ payload }) =>
    () => {
      return API_GET_SURVEYS_TEMPLATE_BY_ID_CALL(payload.id);
    },
  successMock: IS_MOCK_ENABLED({ avoidMockOnDemoMode: true })
    ? MOCK_RESPONSE_GET_TEMPLATE_BY_ID
    : undefined,
});
